import httpClient from '@/core/http/client.service';

const forgotPassword = (data) => httpClient.post('user/baxpassword?_format=json', data);

const resetForgotPassword = (data, token) => httpClient.post('api/v1/user/reset-password?_format=json', {
  password: data,
}, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export default {
  forgotPassword,
  resetForgotPassword,
};
